import {
  AUTH_LOGIN,
  AUTH_LOGOUT,
  AUTH_REQUEST,
  AUTH_SUCCESS,
  AUTH_ERROR,
  AUTH_SET_HIJACK
} from "@/store/types"

import axios from "@/store/axios"

const state = {
  token: null,
  isLoading: false,
  error: null,
  isHijack: false
}

const initToken = localStorage.getItem("token") || ""

if (initToken) {
  state.token = { access: initToken }
}

const getters = {
  getCurrentAccessToken: (state) => (state.token ? state.token.access : null),
  isAuthenticated: (state) => (state.token ? !!state.token.access : false),
  isAuthLoading: (state) => state.isLoading,
  getAuthError: (state) => state.error,
  isAuthHijack: (state) => state.isHijack
}

const actions = {
  [AUTH_LOGIN]: ({ commit }, { username, password, shareToken }) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)

      axios
        .post(`/api/v3/token/`, { username, password, shareToken })
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(AUTH_SUCCESS, resp.data)
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(AUTH_ERROR, err)
          reject(err)
        })
    })
  },
  // Not using arrow function for correct "this" context
  [AUTH_LOGOUT]: function ({ commit }, reset = false) {
    const that = this
    return new Promise((resolve) => {
      commit(AUTH_ERROR)
      if (reset) {
        that.reset()
      }
      resolve()
    })
  }
}

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.isLoading = true
  },
  [AUTH_SUCCESS]: (state, token) => {
    state.isLoading = false

    if (token) {
      state.token = token
      localStorage.setItem("token", token.access)
    }
  },
  [AUTH_ERROR]: (state, err) => {
    state.isLoading = false
    state.error = err
    state.token = null
    localStorage.removeItem("token")
  },
  [AUTH_SET_HIJACK]: (state, hijack) => {
    state.isHijack = hijack
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
